export default __webpack_public_path__ + "static/media/Pin.43064958.svg";